import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import { ukUA } from '@mui/material/locale';

// Компоненти
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard/Dashboard';
import Kindergartens from './pages/Kindergartens/Kindergartens';
import Children from './pages/Children/Children';
import Parents from './pages/Parents/Parents';
import Menus from './pages/Menus/Menus';
import Cameras from './pages/Cameras/Cameras';
import Invites from './pages/Invites/Invites';
import Users from './pages/Users/Users';
import Admins from './pages/Admins/Admins';
import Surveys from './pages/Surveys';
import Login from './pages/Login/Login';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';

// Контекст автентифікації
// import { AuthProvider } from './contexts/AuthContext';

// Створюємо тему з українською локалізацією
const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#1976d2',
      },
      secondary: {
        main: '#dc004e',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h4: {
        fontWeight: 600,
      },
      h5: {
        fontWeight: 600,
      },
      h6: {
        fontWeight: 600,
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: 8,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 12,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          },
        },
      },
    },
  },
  ukUA
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AdminAuthProvider>
        <Router>
          <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="kindergartens" element={<Kindergartens />} />
                <Route path="children" element={<Children />} />
                <Route path="parents" element={<Parents />} />
                <Route path="menus" element={<Menus />} />
                <Route path="cameras" element={<Cameras />} />
                <Route path="invites" element={<Invites />} />
                <Route path="users" element={<Users />} />
                <Route path="surveys" element={<Surveys />} />
                <Route 
                  path="admins" 
                  element={
                    <ProtectedRoute requiredRole="super_admin">
                      <Admins />
                    </ProtectedRoute>
                  } 
                />
              </Route>
            </Routes>
          </Box>
        </Router>
      </AdminAuthProvider>
    </ThemeProvider>
  );
}

export default App;
